import React, { Component, PropTypes } from 'react'

import Header from './header'
import Footer from './footer'
import ListData from './list-data'

class Data extends Component {
  componentDidMount() {
    window.print()
  }

  render() {
    const { data, campus } = this.props

    var from = data.get('header').get('date_from')
    var to = data.get('header').get('date_to')
    if (data.get('header').get('by') === "or") {
      from = data.get('header').get('or_from')
      to = data.get('header').get('or_to')
    }

    return (
      <div id="report-collection" className="container">
        <Header campus={campus} />

        <table className="table table-bordered table-condensed rc-info">
          <tbody>
            <tr>
              <td width="15%">Collection From:</td>
              <td><strong>{data.get('header').get('cashier')}</strong></td>
            </tr>
            <tr>
              <td width="15%">OR/Date Range:</td>
              <td><strong>{from} - {to}</strong></td>
            </tr>
            <tr>
              <td>Fund Type:</td>
              <td><strong>{data.get('header').get('fund')}</strong></td>
            </tr>
          </tbody>
        </table>
        <ListData data={data.get('data')} total={data.get('header').get('total')} />
        <table width="100%" className="sign">
          <tbody>
            <tr>
              <td></td>
              <td width="25%" className="text-center">
                <small>Prepared by:</small>
              </td>
            </tr>
          </tbody>
        </table>
        <Footer time={data.getIn(['header', 'printed_date'])} />
      </div>
    )
  }
}

Data.propTypes = {
  data: PropTypes.object,
  campus: PropTypes.string,
}

export default Data



// WEBPACK FOOTER //
// ./src/containers/Print/Reports/Collections/data.js